import { uniqueId } from "lodash-es";
import type { Group, TrackType } from "./Base";

export interface ThumbMaterial {
  id: string;
  url: string;
  name?: string;
  centerX?: number;
  centerY?: number;
  [k: string]: any;
}
/**
 * 解析文件不能放在片段中：
 * 1. 文件解析是一个耗时操作，需要提前解析好，然后传递给片段
 * 2. 文件可能是网络资源，也可能是本地资源，在片段对象中要收束
 * 3. 不同片段可能共享同一个文件，解析一次即可
 * 4. 片段信息需要转换为文本进行存储（草稿）
 */
export class ThumbGroup implements Group {
  id: string;
  type: TrackType = "thumb";
  materials: ThumbMaterial[];
  activeSourceIndex: number;
  name: string;
  start: number;
  end: any;
  frameCount: number;
  offsetL: number;
  offsetR: number;
  dirty?: boolean; // 记录主轨道素材数量是否有更新
  [k: string]: any;

  constructor(
    materials: ThumbMaterial[],
    options: { start?: number; frameCount?: number }
  ) {
    // 设置ID
    this.id = uniqueId();
    this.activeSourceIndex = 0;
    // 设置图片信息
    this.materials = materials;
    // 获取文件名称
    this.name = "封面";
    // 获取文件类型
    // 设置轨道信息
    this.frameCount = options.frameCount ?? 1000; // 默认封面2s
    this.start = options.start ?? 0;
    this.end = this.start + this.frameCount;
  }
}
